import { Toaster as SonnerToaster } from 'sonner';

export const Toaster = () => (
  <SonnerToaster
    position="top-center"
    richColors
    expand
    visibleToasts={5}
    closeButton
    toastOptions={{
      classNames: {
        toast:
          'rounded-2xl border border-border/50 bg-background/95 text-foreground shadow-2xl backdrop-blur supports-[backdrop-filter]:bg-background/75 dark:border-border/70 dark:bg-foreground/10',
        title: 'text-sm font-medium',
        description: 'text-xs text-muted-foreground',
        actionButton:
          'inline-flex h-8 items-center rounded-full bg-primary px-3 text-xs font-semibold text-primary-foreground hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
        cancelButton:
          'inline-flex h-8 items-center rounded-full border border-border/80 px-3 text-xs font-semibold hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2'
      }
    }}
  />
);

export default Toaster;
